/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {ThorBigWinCountUp} from "./ThorBigWinCountUp";
import {ThorBigWinView} from "./ThorBigWinView";

export class ThorBigWinController extends StepCountUpBigWinController {

    private _gameView:ThorBigWinView;
    private _winCountUp:ThorBigWinCountUp;

    public static _gameView:ThorBigWinView;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : true});

        this._gameView = new ThorBigWinView();
        ThorBigWinController._gameView = this._gameView;
        this._winCountUp = new ThorBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, (GameConfig.instance.GAME_HEIGHT * 0.5));
        StageManager.getLayer(ThorGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(ThorSoundConfig.instance.BIG_WIN);
        SlotGame.sound.fadeAmbience(0, 500);
    }

    protected stopAllSounds():void {
        SlotGame.sound.stopEffect(ThorSoundConfig.instance.BIG_WIN);
        SlotGame.sound.playEffect(this.getBigWinEndSound(this._winLevel));
        SlotGame.sound.fadeAmbience(1, 500);
    }

    private getBigWinEndSound(winLevel:number):string {
        switch(winLevel) {
            case 0 :
                return ThorSoundConfig.instance.BIG_WIN_END_01;

            case 1 :
                return ThorSoundConfig.instance.BIG_WIN_END_02;

            case 2 :
                return ThorSoundConfig.instance.BIG_WIN_END_03;

            default :
                return ThorSoundConfig.instance.BIG_WIN_END_01;
        }
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(level, this._winRatios[level]);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._winCountUp.abort(this._gameData!.singleWin, isAborted);
        this._gameView.playEndingAnimation(this._winRatios[this._winLevel], isAborted);
        SlotGame.winFieldController.showWinField(this._gameData!.totalWin);
    }
}